
























































































































































































































































































































































import DatePicker from '@/components/ui/DatePicker.vue'
import { formatarMoeda } from '@/shareds/formatadores'
import { DetalhesDoPagamento, FormaDePagamento, FormPagamento, PontoDeVendaComTurno, Titulo } from '@/models'
import { BaixaDePagamento, BaixaDePagamentoForm, TipoDeTransacaoDaBaixaDePagamento } from '@/models/financeiro/BaixaDePagamento'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CreateBaixaDePagamentoUseCase, FindBaixaDePagamentoUseCase, FindTituloUseCase } from '@/usecases'
import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'
import { imprimirComprovanteDeRecebivelComTef } from '@/shareds/venda-shareds'
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase'
import { obrigatorio } from '@/shareds/regras-de-form'
import { apurarEncargosDoTitulo, baixasParaEncargos } from '@/shareds/encargos-do-titulo'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import Decimal from 'decimal.js'
import type { PagamentoServiceAdapter } from '@/usecases'
import { Inject } from 'inversify-props'
import { criarFormPagamento } from '@/shareds/shared-pagamento'
import { v4 as uuidv4 } from 'uuid'

const TEF_DA_BAIXA_EM_ANDAMENTO = 'TEF_DA_BAIXA_EM_ANDAMENTO'

const VALIDADE_DO_TEF_EM_ANDAMENTO_EM_MS = 15 * 60 * 1000

interface TefDaBaixaEmAndamento {
	criadoEm: number
	tituloId: string
	pontoDeVendaId: string
	ehControlPay: boolean
	identificador: string
	detalhesDoPagamentoId: string
	formaDePagamento: string
	data: string
	horas: string
	baixaDePagamento: BaixaDePagamentoForm
	tipoDeDesconto: 'valorFixo' | 'porcentagem'
	valorDeDescontoNosJuros: number
	valorDeDescontoNaMulta: number
	valorDescontoTituloEmPorcentagem: number
	valorDescontoJurosDoTituloEmPorcentagem: number
	valorDescontoMultaDoTituloEmPorcentagem: number
	valorJurosSobreBaixa: number | null
	valorDaMultaSobreBaixa: number | null
	valorIntegroDoTituloRestante: number
	valorFaltante: number | null
	valorFaltanteInicial: number
	valorFaltanteDoTitulo: number | null
	valorTotalTitulo: number | null
}

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeBaixasDePagamento extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean
	@Prop({ type: Boolean, default: false }) contasAPagar!: boolean
	@Ref() menu!: {
		save: (value?: any) => void
	}
	
	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda

	data = ''
    horas = ''
	salvando = false
	mostra = false
	titulo: Titulo | null = null
	valorFaltante: number | null = null
	valorFaltanteAtualizado: number | null = null
	formaDePagamento = ''
	isEdicao: boolean | null = null
	valorJurosSobreBaixa: number | null = null
	valorDaMultaSobreBaixa: number | null = null
	valorFaltanteDoTitulo: number | null = null
	// Armadilha: este campo é só escrito (nos dois ramos de calcularValorFaltante) e nunca
	// lido. O número que a tela mostra e que o distribuidor consome é
	// baixaDePagamento.valorTotalTitulo, que é outro campo. Mexer aqui não muda nada na tela.
	valorTotalTitulo: number | null = null
	// dataInicial é a sentinela que calcularValorFaltante usa para detectar troca de data:
	// enquanto data === dataInicial os valores já distribuídos são preservados.
	dataInicial = ''
	estadoDistribuidor = 0
	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	valorDeDescontoNosJuros: number | 0 = 0
	valorDeDescontoNaMulta: number | 0 = 0
	valorDescontoTituloEmPorcentagem: number | 0 = 0
	valorDescontoJurosDoTituloEmPorcentagem: number | 0 = 0
	valorDescontoMultaDoTituloEmPorcentagem: number | 0 = 0
	// Armadilha: só o ramo de juros COMPOSTO de calcularValorFaltante preenche este campo.
	// Ele é lido em salvarBaixa para transformar o desconto do título em porcentagem em
	// reais, então em título de juros simples ele continua 0 e o desconto percentual do
	// título vai zerado para o backend.
	valorIntegroDoTituloRestante: number | 0 = 0
	valorFaltanteInicial: number | 0 = 0
	valorRecebidoParaRedistribuir: number | null = null
	versaoDaRedistribuicao = 0
	mostraAguardandoPagamentoTef = false
	aguardandoPagamentoTef = false
	situacaoPagamentoTef = ''
	retornoDoAdquirenteTef: string | null = null
	contadorTef = 0
	tentativasEfetuarTef = 0
	pagamentoTef: FormPagamento | null = null
	identificadorDoPagamentoTef = ''

	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter

	createBaixaDePagamentoUseCase = new CreateBaixaDePagamentoUseCase()
	findBaixaDePagamentoUseCase = new FindBaixaDePagamentoUseCase()
	findTituloUseCase = new FindTituloUseCase()
	findPdvUseCase = new FindPdvUseCase()

	pdvOptions: PontoDeVendaComTurno[] = []

	baixaDePagamento: BaixaDePagamentoForm = {
		titulo: null,
		transactionId: '',
		valorPagamento: 0,
		valorTaxa: 0,
		dataHoraPagamento: '',
		isTaxa: false,
		isIntegracao: false,
		formaDePagamento: null,
		valorDesconto: 0,
		turnoDeVendaId: null,
		tipoDeTransacao: null,
		estornado: null,
		valorJurosSobreBaixa: 0,
		valorDaMultaSobreBaixa: 0,
		valorTotalTitulo: 0,
		valorDeDescontoNosJuros: 0,
		valorDeDescontoNaMulta: 0,
		tipoDeDesconto: this.tipoDeDesconto,
	}

	edicaoBaixaPagamento = {
		id: '',
		dataHoraPagamento: '',
	}

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	// Hoje esta lista é igual, item por item, a opcoesDeFormaDePagamento, então o ternário do
	// template (retornoCrediario ? caixa : normal) escolhe entre duas listas idênticas. O motivo da
	// separação não está claro no código; unificar as duas hoje não mudaria a tela, mas tiraria o
	// ponto onde o caixa poderia passar a ter opções próprias.
	opcoesDeFormaDePagamentoCaixa: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	opcoesDeFormaDePagamentoTef: FormaDePagamento[] = [
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
	]

	get configuracaoDaLojaDoTitulo() {
		return this.titulo?.loja?.configuracaoDaLoja || null
	}

	get integracaoTefAtiva() {
		const configuracao = this.configuracaoDaLojaDoTitulo
		if (!configuracao) return false

		return !!configuracao.integracaoControlPayAtiva || !!configuracao.integracaoSitefAtiva
	}

	get ehTituloDeCrediarioAReceber() {
		if (!this.titulo) return false

		return this.titulo.fluxo === 'Entrada' && this.titulo.formaDePagamento === 'CREDIARIO'
	}

	get permiteTefNaBaixa() {
		return !this.contasAPagar && this.ehTituloDeCrediarioAReceber && this.integracaoTefAtiva
	}

	get opcoesDeFormaDePagamentoDaBaixa(): FormaDePagamento[] {
		const opcoes = this.retornoCrediario
			? this.opcoesDeFormaDePagamentoCaixa
			: this.opcoesDeFormaDePagamento

		if (!this.permiteTefNaBaixa) return opcoes

		return [...opcoes, ...this.opcoesDeFormaDePagamentoTef]
	}

	get ehBaixaComTef() {
		return this.opcoesDeFormaDePagamentoTef.includes(this.formaDePagamento as FormaDePagamento)
	}

	get pdvDaBaixa() {
		return this.pdvOptions
			.find(pdv => pdv.turnoDeVendaId === this.baixaDePagamento.turnoDeVendaId) || null
	}

	get valorTotalRecebidoNaBaixa() {
		return Number(
			new Decimal(Number(this.baixaDePagamento.valorPagamento || 0))
				.plus(Number(this.baixaDePagamento.valorJurosSobreBaixa || 0))
				.plus(Number(this.baixaDePagamento.valorDaMultaSobreBaixa || 0))
				.toFixed(2),
		)
	}

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	get podeAplicarDescontoNaBaixa() {
		return UserLoginStore.perfil?.podeConcederDescontoNaBaixaDePagamento ?? true
	}

	/**
	 * Armadilha dupla nesta regra de form.
	 *
	 * 1) O argumento `data` chega no formato de exibição do DatePicker (DD/MM/YYYY, porque as :rules
	 *    vão via $attrs para o v-text-field interno, que mostra dataFormatada), enquanto this.data é
	 *    o ISO YYYY-MM-DD. Daí o moment(data, 'DD/MM/YYYY') mais abaixo e a comparação de cima usar
	 *    this.data, e não o argumento.
	 * 2) new Date('YYYY-MM-DD') é lido como meia-noite UTC. Em fuso -03 isso desloca a fronteira do
	 *    "não pode ser maior que hoje" em 3 horas, então a data de amanhã só é recusada até as 21h
	 *    do horário local.
	 *
	 * Além disso a regra escreve estado (this.data) e dispara alerta global, o que não é usual em
	 * :rules; e o return vazio faz o Vuetify considerar o campo válido nesse caminho.
	 */
	validarDataDePagamento(data) {
		if (!data) return true
		if (!this.titulo) return true

		if (new Date(this.data).getTime() > Date.now()) {
			this.data = new Date().toISOString().substring(0, 10);
			AlertModule.setError('A data não pode ser maior que a data atual');
			return;
		}

		const dataFormatada = moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
		const dataDeCompetencia = this.titulo.dataDeCompetencia
		
		return dataFormatada < dataDeCompetencia ? 'A data do pagamento não pode ser anterior à data de competência' : true
	}

	@Watch('mostra', { immediate: true })
	changeDate() {
		if(!this.mostra) return

		this.data = moment().format('YYYY-MM-DD')
		this.horas = new Date().toLocaleTimeString('pt-BR')
	}

	get fluxo(){
		return this.titulo?.fluxo
	}	

	/**
	 * Descarta a distribuição já feita (multa, juros e principal) e devolve o distribuidor ao
	 * estado inicial.
	 *
	 * Este bloco estava duplicado byte a byte em resetarValorCalculadoDoTitulo e no início de
	 * calcularValorFaltante (ramo "a data mudou"). A ordem das atribuições é a original.
	 *
	 * Armadilha: além de zerar, ele carimba dataInicial com a data atual, e é esse carimbo que
	 * faz calcularValorFaltante deixar de enxergar troca de data. Chamar isto fora de hora
	 * engole o reset seguinte.
	 */
	private reiniciarDistribuicaoDaBaixa() {
		this.baixaDePagamento.valorTotalTitulo = 0
		this.dataInicial = this.data;
		this.baixaDePagamento.valorDaMultaSobreBaixa = 0
		this.baixaDePagamento.valorJurosSobreBaixa = 0
		this.baixaDePagamento.valorPagamento = 0
		this.estadoDistribuidor = 0
	}

	@Watch('baixaDePagamento.valorDesconto', { immediate: true})
	@Watch('valorDescontoJurosDoTituloEmPorcentagem', { immediate: true})
	@Watch('valorDescontoMultaDoTituloEmPorcentagem', { immediate: true})
	@Watch('valorDescontoTituloEmPorcentagem', { immediate: true})
	async resetarValorCalculadoDoTitulo(){
		const versao = ++this.versaoDaRedistribuicao

		const valorRecebidoDigitado = this.baixaDePagamento.valorTotalTitulo
		const temValorRecebido = Number(valorRecebidoDigitado) > 0

		if (this.estadoDistribuidor === 1 && temValorRecebido) {
			this.valorRecebidoParaRedistribuir = Number(valorRecebidoDigitado)
		}

		const calculadoraDesligada = this.estadoDistribuidor === 0

		this.reiniciarDistribuicaoDaBaixa()

		if (calculadoraDesligada && temValorRecebido) {
			this.baixaDePagamento.valorTotalTitulo = valorRecebidoDigitado
		}

		await this.calcularValorFaltante()

		if (versao !== this.versaoDaRedistribuicao) return

		this.redistribuirValorRecebido()
	}

	private redistribuirValorRecebido() {
		const valorRecebido = this.valorRecebidoParaRedistribuir
		this.valorRecebidoParaRedistribuir = null

		if (valorRecebido === null || !this.mostra || !this.titulo) return

		this.baixaDePagamento.valorTotalTitulo = valorRecebido
		this.distribuirValores()
		this.estadoDistribuidor = 1
	}

	private cancelarRedistribuicaoPendente() {
		this.versaoDaRedistribuicao++
		this.valorRecebidoParaRedistribuir = null
	}

	@Watch('data', { deep: true, immediate: true })
	@Watch('tipoDeDesconto', { immediate: true })
	async calcularValorFaltante() {
		if(this.valorFaltanteAtualizado === null || !this.titulo) return

		if (this.data !== this.dataInicial) {
			this.reiniciarDistribuicaoDaBaixa()
		}

		if (
			this.titulo.formaDePagamento === "CREDIARIO" &&
			this.titulo.fluxo === 'Entrada'
		) {
			const params = {
				tituloId: this.titulo.id,
			}
			const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
				params,
			)

			// Mesma conta do backend (MotorDeEncargosDoTitulo), que é quem grava o título depois da
			// baixa: o pagamento quita primeiro multa e juros, e os encargos correm só sobre o que
			// falta pagar, período a período entre as baixas. Até o ticket 42385 este diálogo
			// calculava juros e multa sobre o valor cheio da parcela, e só descontava o que já tinha
			// sido pago no fim da conta.
			const apurado = apurarEncargosDoTitulo(
				this.titulo,
				baixasParaEncargos(baixasDoTitulo.content),
				this.data,
				this.titulo.loja?.configuracaoDaLoja?.calcularJurosComMulta || false,
			)
			if (!apurado) return

			// O que já está lançado nesta baixa sai do saldo apurado, como sempre saiu.
			this.valorJurosSobreBaixa = Math.max(0, Number((apurado.juros - (this.baixaDePagamento.valorJurosSobreBaixa || 0)).toFixed(2)))
			this.valorDaMultaSobreBaixa = Math.max(0, Number((apurado.multa - (this.baixaDePagamento.valorDaMultaSobreBaixa || 0)).toFixed(2)))

			this.valorIntegroDoTituloRestante = apurado.principal
			this.valorFaltanteDoTitulo = Math.max(0, Number((apurado.principal
				- (this.baixaDePagamento.valorPagamento || 0)
				- (this.baixaDePagamento.valorDesconto || 0)).toFixed(2)))

			this.valorFaltante = apurado.valorAtualizado
			this.valorTotalTitulo = Number(this.valorJurosSobreBaixa)
				+ Number(this.valorDaMultaSobreBaixa)
				+ Number(this.valorFaltanteDoTitulo)
		} else {
			if (this.valorFaltante !== null && this.baixaDePagamento.valorPagamento !== null && this.baixaDePagamento.valorDesconto !== null) {
				this.valorFaltanteAtualizado = Number(this.valorFaltante) - Number(this.baixaDePagamento.valorPagamento) - Number(this.baixaDePagamento.valorDesconto)
				this.valorFaltanteDoTitulo = this.valorFaltanteAtualizado

				const valorTitulo = new Decimal(this.titulo.valor);
				const params = {
					tituloId: this.titulo.id,
				}
				const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId(
					params,
				)
				const somaValorPagamentoBaixasExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
					return soma + Number(baixa.valorPagamento || 0)
				}, 0);
				const somaValorPagamentoDescontoExistentes = baixasDoTitulo.content.reduce((soma, baixa) => {
					return soma + Number(baixa.valorDesconto || 0)
				}, 0)

				this.valorTotalTitulo = valorTitulo.toNumber() - 
					this.baixaDePagamento.valorPagamento - 
					somaValorPagamentoBaixasExistentes - 
					somaValorPagamentoDescontoExistentes -
					Number(this.baixaDePagamento.valorDesconto || 0);
			}
		}
	}

	limparValorZeradoAoFocar() {
		const valor = this.baixaDePagamento.valorTotalTitulo as number | string | null
		if (valor !== null && valor !== '' && Number(valor) === 0) {
			// campo type="number" aceita string vazia; evita o usuário ter que apagar o 0
			(this.baixaDePagamento as { valorTotalTitulo: number | string }).valorTotalTitulo = ''
		}
	}

	restaurarValorZeradoAoSair() {
		const valor = this.baixaDePagamento.valorTotalTitulo as number | string | null
		if (valor === null || valor === '') {
			this.baixaDePagamento.valorTotalTitulo = 0
		}
	}

	distribuirValores() {
		if (!this.baixaDePagamento.valorTotalTitulo) return;
		if (this.calcularReducaoDeTituloCompleto <= 0) return;

		this.baixaDePagamento.valorDaMultaSobreBaixa = 0
		this.baixaDePagamento.valorJurosSobreBaixa = 0
		this.baixaDePagamento.valorPagamento = 0

		let valorDeDescontoNosJurosFormatado = 0;
		let valorDeDescontoNaMultaFormatado = 0;

		if(this.tipoDeDesconto === 'porcentagem'){
			if(this.valorDescontoMultaDoTituloEmPorcentagem > 100) this.valorDescontoMultaDoTituloEmPorcentagem = 100
			if(this.valorDescontoJurosDoTituloEmPorcentagem > 100) this.valorDescontoJurosDoTituloEmPorcentagem = 100

			valorDeDescontoNosJurosFormatado = this.valorJurosSobreBaixa ? Number(((this.valorJurosSobreBaixa * this.valorDescontoJurosDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
			valorDeDescontoNaMultaFormatado = this.valorDaMultaSobreBaixa ? Number(((this.valorDaMultaSobreBaixa * this.valorDescontoMultaDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
		}		

		const valorDisponivel = Number(this.baixaDePagamento.valorTotalTitulo);
		
		if (valorDisponivel <= 0) {
			this.baixaDePagamento.valorDaMultaSobreBaixa = 0;
			this.baixaDePagamento.valorJurosSobreBaixa = 0;
			this.baixaDePagamento.valorPagamento = 0;
			return;
		}

		const multa = Math.max(0, Number(this.valorDaMultaSobreBaixa || 0) - (this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta));
		const juros = Math.max(0, Number(this.valorJurosSobreBaixa || 0) - (this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros));
		const valorFaltanteTitulo = Math.max(0, Number(this.valorFaltanteDoTitulo || 0));

		let restante = valorDisponivel;
		
		this.baixaDePagamento.valorDaMultaSobreBaixa = Number(Math.min(multa, restante).toFixed(2));
		restante = Number((restante - (this.baixaDePagamento.valorDaMultaSobreBaixa)).toFixed(2));
		
		this.baixaDePagamento.valorJurosSobreBaixa = Number(Math.min(juros, restante).toFixed(2));
		restante = Number((restante - (this.baixaDePagamento.valorJurosSobreBaixa)).toFixed(2));
		
		const valor = Math.min((valorFaltanteTitulo), restante);
		this.baixaDePagamento.valorPagamento = parseFloat(valor.toFixed(2));
	}

	async mostrarDialogo(titulo: Titulo | null, valorFaltante: number, isEdicao: boolean, baixa?: BaixaDePagamento) {
		this.pdvOptions = []
		this.mostra = true
		this.titulo = titulo ? titulo : null
		this.valorFaltante = valorFaltante
		this.valorFaltanteInicial = this.valorFaltante
		this.valorFaltanteAtualizado = valorFaltante
		this.isEdicao = isEdicao
		this.estadoDistribuidor = 0
		if(baixa){
			this.edicaoBaixaPagamento = { 
				...baixa,
				id: baixa.id,
				dataHoraPagamento: baixa.dataHoraPagamento,
			}
		}
		
		this.preencherPdvAutomatico();
		await this.buscarPdvAberto();

		if (!isEdicao) await this.retomarTefEmAndamento();
	}

	/**
	 * Armadilha: este método é ao mesmo tempo regra de :rules do campo "Desconto no Titulo" e
	 * watcher de baixaDePagamento.valorPagamento, então ele dispara alerta global enquanto o
	 * operador digita o pagamento, mesmo sem tocar no desconto.
	 *
	 * E como regra ele devolve o retorno de AlertModule.setError (undefined, é uma Mutation) em vez
	 * de uma string: o Vuetify não marca o campo como inválido, o form continua válido e quem
	 * barra o salvamento é a mesma checagem repetida dentro de salvarBaixa. Trocar por string muda
	 * o que o usuário vê.
	 */
	@Watch('baixaDePagamento.valorPagamento', { immediate: true })
	validarDesconto() {
		if (this.valorFaltante === null) {
			return 'Valor faltante não definido'
		}

		if ((Number(this.baixaDePagamento.valorDesconto) + Number(this.baixaDePagamento.valorTaxa)) > Number(this.valorFaltanteInicial)) {
			return AlertModule.setError('A soma do desconto, pagamento e taxa não pode ser maior que o valor faltante')
		}

		return true
	}

	@Watch('valorDeDescontoNosJuros')
	validarDescontoDeJuros() {
		if (this.valorJurosSobreBaixa === null) return true

		const descontoNumerico = Number(this.valorDeDescontoNosJuros)

		if (descontoNumerico > Math.max(0, Number(this.valorJurosSobreBaixa))) {
			return 'A soma do desconto excede o total disponivel no titulo'
		}

		return true
	}

	@Watch('valorDeDescontoNaMulta')
	validarDescontoDeMulta() {
		if (this.valorDaMultaSobreBaixa === null) return true

		const descontoNumerico = Number(this.valorDeDescontoNaMulta)

		if (descontoNumerico > Math.max(0, Number(this.valorDaMultaSobreBaixa))) {
			return 'A soma do desconto excede o total disponivel no titulo'
		}

		return true
	}
	
	preencherPdvAutomatico() {
		if (this.contasAPagar) return;
		const turnoDeVenda = JSON.parse(localStorage.getItem('TURNO_DE_VENDA_STORAGE') || 'null')

		if (turnoDeVenda && turnoDeVenda.pontoDeVenda && this.titulo && this.titulo.loja) {

			if (turnoDeVenda.pontoDeVenda.loja.id === this.titulo.loja.id) {
				const pdv = {
					turnoDeVendaId: turnoDeVenda.id,
					nomePontoDeVenda: turnoDeVenda.pontoDeVenda.nome,
					pontoDeVendaId: turnoDeVenda.pontoDeVenda.id,
					idTerminalControlPay: turnoDeVenda.pontoDeVenda.idTerminalControlPay,
					idTerminalDoPdvSitef: turnoDeVenda.pontoDeVenda.idTerminalDoPdvSitef,
				};

				if (!this.pdvOptions.some(p => p.turnoDeVendaId === pdv.turnoDeVendaId)) {
					this.pdvOptions = [pdv, ...this.pdvOptions];
				}

				if (!this.baixaDePagamento.turnoDeVendaId) {
					this.baixaDePagamento.turnoDeVendaId = pdv.turnoDeVendaId;
				}
			}
		}
	}

	async buscarPdvAberto() {
		if (!this.titulo || !this.titulo.loja) return;

		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(this.titulo.loja.id);

		const pdvsAtualizados = this.pdvOptions.map(pdvCacheado =>
			pdvs.find(pdv => pdv.turnoDeVendaId === pdvCacheado.turnoDeVendaId) || pdvCacheado,
		);
		const turnosJaListados = pdvsAtualizados.map(pdv => pdv.turnoDeVendaId);

		this.pdvOptions = [
			...pdvsAtualizados,
			...pdvs.filter(pdv => !turnosJaListados.includes(pdv.turnoDeVendaId)),
		];
	}

	async salvarBaixa() {
		if (!this.baixaDePagamento) return
		if (!this.titulo) return
		if (!this.form.validate()) return

		if(this.isEdicao) {
			try{
				await this.createBaixaDePagamentoUseCase.updateDataDaBaixa(this.edicaoBaixaPagamento.id, new Date(`${this.data}T${this.horas}`))
				this.$emit('atualizar', this.baixaDePagamento)
				this.limparDados()
				this.salvando = false
				this.mostra = false
				AlertModule.setSuccess('Dados salvos com sucesso!')
				return
			} catch(e){
				AlertModule.setError(e)
			}
			
		}

		if (this.valorFaltante === null) {
			return AlertModule.setError('Valor faltante não pode ser nulo!')
		}

		if (((!this.baixaDePagamento.valorPagamento && !this.baixaDePagamento.valorDesconto && !this.baixaDePagamento.valorJurosSobreBaixa && !this.baixaDePagamento.valorDaMultaSobreBaixa) 
			|| (this.baixaDePagamento.valorPagamento <= 0 && this.baixaDePagamento.valorDesconto <=0 && this.baixaDePagamento.valorJurosSobreBaixa <= 0 && !this.baixaDePagamento.valorDaMultaSobreBaixa))
			&& (this.valorDeDescontoNosJuros || 0) + (this.valorDeDescontoNaMulta || 0) <= 0 &&
			(this.valorDescontoTituloEmPorcentagem <= 0 &&
			this.valorDescontoJurosDoTituloEmPorcentagem <= 0 &&
			this.valorDescontoMultaDoTituloEmPorcentagem <= 0)
		) {
			return AlertModule.setError('Valor de pagamento, desconto, Juros ou Multa é obrigatório!')
		}

		const valorDistribuidoNaBaixa = Number(this.baixaDePagamento.valorPagamento || 0)
			+ Number(this.baixaDePagamento.valorJurosSobreBaixa || 0)
			+ Number(this.baixaDePagamento.valorDaMultaSobreBaixa || 0)

		if (this.fluxo === 'Entrada' && Number(this.baixaDePagamento.valorTotalTitulo) > 0 && valorDistribuidoNaBaixa <= 0 && this.calcularReducaoDeTituloCompleto > 0) {
			return AlertModule.setError('O valor recebido não foi distribuído. Clique na calculadora para distribuir o valor antes de salvar.')
		}

		if ((Number(this.baixaDePagamento.valorDesconto) + Number(this.baixaDePagamento.valorTaxa)) > Number(this.valorFaltanteInicial)) {
			return AlertModule.setError('A soma do desconto, pagamento e taxa não pode ser maior que o valor faltante')
		}

		if ( this.baixaDePagamento.valorTaxa > this.valorFaltanteInicial) {
			return AlertModule.setError('Valor de taxa não pode ser maior que o valor faltante!')
		}
		if (!this.formaDePagamento) {
			return AlertModule.setError('Forma de pagamento é obrigatória!')
		}
		if (!this.baixaDePagamento.turnoDeVendaId && !this.contasAPagar) {
			return AlertModule.setError('Necessário Ponto De Venda')
		}

		if (this.ehBaixaComTef) {
			return await this.iniciarPagamentoTef()
		}

		await this.efetivarBaixa()
	}

	async efetivarBaixa(comprovantesDoTef: string[] = []) {
		if (!this.baixaDePagamento) return
		if (!this.titulo) return

		try {
			this.salvando = true
			this.baixaDePagamento.titulo = this.titulo

			let valorDeDescontoNosJurosFormatado = 0;
			let valorDeDescontoNaMultaFormatado = 0;
			let valorDeDescontoNoTituloFormatado = 0;

			if(this.tipoDeDesconto === 'porcentagem'){
				if(this.valorDescontoMultaDoTituloEmPorcentagem > 100) this.valorDescontoMultaDoTituloEmPorcentagem = 100
				if(this.valorDescontoJurosDoTituloEmPorcentagem > 100) this.valorDescontoJurosDoTituloEmPorcentagem = 100
				if(this.valorDescontoTituloEmPorcentagem > 100) this.valorDescontoTituloEmPorcentagem = 100

				// O percentual incide sobre o saldo apurado na data escolhida (valorJurosSobreBaixa e
				// valorDaMultaSobreBaixa), e não sobre titulo.juros/titulo.multa, que são o valor
				// gravado pelo lote até hoje. Em baixa retroativa os dois divergem, e o desconto
				// registrado saía maior que o exibido na tela e concedido pelo operador.
				valorDeDescontoNosJurosFormatado = this.valorJurosSobreBaixa ? Number(((Number(this.valorJurosSobreBaixa) * this.valorDescontoJurosDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
				valorDeDescontoNaMultaFormatado = this.valorDaMultaSobreBaixa ? Number(((Number(this.valorDaMultaSobreBaixa) * this.valorDescontoMultaDoTituloEmPorcentagem) / 100).toFixed(2)) : 0
				valorDeDescontoNoTituloFormatado = this.valorIntegroDoTituloRestante ? Number(((Number(this.valorIntegroDoTituloRestante) * this.valorDescontoTituloEmPorcentagem) / 100).toFixed(2)) : 0
			}

			const somenteDesconto = this.baixaDePagamento.valorPagamento + 
				this.baixaDePagamento.valorJurosSobreBaixa + 
				this.baixaDePagamento.valorDaMultaSobreBaixa <= 0 && 
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNoTituloFormatado : this.baixaDePagamento.valorDesconto) +
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros) + 
				Number(this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta) > 0

			const tipoDeDesconto = (Number(this.valorDeDescontoNosJuros || 0) + 
				Number(this.valorDeDescontoNaMulta || 0) + 
				Number(this.baixaDePagamento.valorDesconto || 0) +
				Number(valorDeDescontoNosJurosFormatado) +
				Number(valorDeDescontoNaMultaFormatado) +
				Number(valorDeDescontoNoTituloFormatado)) > 0 ? this.tipoDeDesconto : 'semDesconto'

			this.baixaDePagamento.formaDePagamento = this.formaDePagamento
			this.baixaDePagamento.dataHoraPagamento = `${this.data}T${this.horas}`
			this.baixaDePagamento = {
				...this.baixaDePagamento,
				tipoDeTransacao: TipoDeTransacaoDaBaixaDePagamento.BAIXA,
				estornado: false,
				titulo: {
					...this.titulo,
					valorAtualizado: Number(this.calcularReducaoDeTituloCompleto),
				},
				valorPagamento: this.baixaDePagamento.valorPagamento,
				valorJurosSobreBaixa: this.baixaDePagamento.valorJurosSobreBaixa || 0,
				valorDaMultaSobreBaixa: this.baixaDePagamento.valorDaMultaSobreBaixa || 0,
				valorDesconto: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNoTituloFormatado : this.baixaDePagamento.valorDesconto,
				valorDeDescontoNosJuros: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNosJurosFormatado : this.valorDeDescontoNosJuros,
				valorDeDescontoNaMulta: this.tipoDeDesconto === 'porcentagem' ? valorDeDescontoNaMultaFormatado : this.valorDeDescontoNaMulta,
				tipoDeDesconto: tipoDeDesconto,
				valorAcrescimo: this.acrescimo > 0 ? this.acrescimo : undefined,
			}

			const comprovanteDaBaixa = await this.createBaixaDePagamentoUseCase.create({ ...this.baixaDePagamento })

			this.limparEstadoDoTefEmAndamento()

			if (this.titulo.fluxo === 'Entrada' && !somenteDesconto){
				await imprimirComprovanteDeRecebivelComTef(comprovanteDaBaixa, comprovantesDoTef)
			} else {
				AlertModule.setSuccess("Baixa efetuada!")
			}
			this.$emit('atualizar', this.baixaDePagamento)
			this.limparDados()
	
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
			this.limparDados()
		}
	}

	async iniciarPagamentoTef() {
		if (!this.titulo || !this.titulo.loja) return

		if (this.contasAPagar || !this.ehTituloDeCrediarioAReceber) {
			return AlertModule.setError('Pagamento TEF disponível apenas para título de crediário do contas a receber.')
		}

		const configuracao = this.configuracaoDaLojaDoTitulo

		if (!configuracao || !this.integracaoTefAtiva) {
			return AlertModule.setError('A loja do título não possui integração TEF ativa.')
		}

		if (this.valorTotalRecebidoNaBaixa <= 0) {
			return AlertModule.setError('Valor de pagamento é obrigatório para efetuar o pagamento TEF.')
		}

		let pdv: PontoDeVendaComTurno | null = null

		try {
			this.salvando = true

			const tituloDesatualizado = await this.validarTituloParaPagamentoTef()

			if (tituloDesatualizado) {
				return AlertModule.setError(tituloDesatualizado)
			}

			pdv = await this.buscarPdvAbertoDaBaixa()
		} catch (error: any) {
			return AlertModule.setError(error)
		} finally {
			this.salvando = false
		}

		const pontoDeVendaId = pdv?.pontoDeVendaId

		if (!pdv || !pontoDeVendaId) {
			return AlertModule.setError('O turno do PDV selecionado não está mais aberto. Selecione outro PDV.')
		}

		const ehControlPay = !!configuracao.integracaoControlPayAtiva

		if (ehControlPay) {
			if (!pdv.idTerminalControlPay) {
				return AlertModule.setError(`O PDV ${pdv.nomePontoDeVenda} não possui terminal TEF cadastrado.`)
			}
		} else {
			if (!configuracao.idTerminalDaLojaSitef) {
				return AlertModule.setError('Necessário ter terminal Id configurado na loja.')
			}

			if (!pdv.idTerminalDoPdvSitef) {
				return AlertModule.setError(`O PDV ${pdv.nomePontoDeVenda} não possui terminal TEF cadastrado.`)
			}
		}

		const tipoDePagamento = await this.buscarTipoDePagamentoDoTef()

		if (!tipoDePagamento) return

		if (!ehControlPay && pdv.idTerminalDoPdvSitef) {
			const processoSitef = await this.pagamentoService.findProcessoSitefProcessandoByTerminal(
				pdv.idTerminalDoPdvSitef,
				configuracao.idTerminalDaLojaSitef,
			)

			if (processoSitef) {
				return AlertModule.setWarning('Estão sendo executadas as transações pendentes do TEF, aguarde a conclusão para tentar novamente.')
			}
		}

		const pagamento = criarFormPagamento()
		pagamento.tipoDePagamento = tipoDePagamento
		pagamento.valor = this.valorTotalRecebidoNaBaixa
		pagamento.qtdeDeParcelas = 1

		this.pagamentoTef = pagamento
		this.identificadorDoPagamentoTef = uuidv4()
		this.contadorTef = 0
		this.tentativasEfetuarTef = 0
		this.aguardandoPagamentoTef = false
		this.retornoDoAdquirenteTef = null
		this.situacaoPagamentoTef = 'Pagamento Iniciado'
		this.mostraAguardandoPagamentoTef = true
		this.salvando = true

		if (ehControlPay) {
			this.efetuarPagamentoTefControlPay(pontoDeVendaId)
		} else {
			this.efetuarPagamentoTefSitef(pontoDeVendaId)
		}
	}

	async buscarPdvAbertoDaBaixa() {
		if (!this.titulo || !this.titulo.loja) return null

		const pdvs = await this.findPdvUseCase.buscarPdvSemTurno(this.titulo.loja.id)

		return pdvs.find(pdv => pdv.turnoDeVendaId === this.baixaDePagamento.turnoDeVendaId) || null
	}

	async baixaJaExisteParaODetalhe(detalhesDoPagamentoId: string) {
		if (!this.titulo) return false

		const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId({
			tituloId: this.titulo.id,
		})

		return baixasDoTitulo.content
			.some(baixa => baixa.detalhesDoPagamentoId === detalhesDoPagamentoId)
	}

	async validarTituloParaPagamentoTef() {
		if (!this.titulo) return 'Título não encontrado.'

		const tituloAtualizado = await this.findTituloUseCase.findById(this.titulo.id)

		if (tituloAtualizado.situacao !== 'Aberto') {
			return `O título não está mais em aberto (situação: ${tituloAtualizado.situacao}). Reabra a tela de títulos.`
		}

		const baixasDoTitulo = await this.findBaixaDePagamentoUseCase.findByTituloId({
			tituloId: this.titulo.id,
		})

		const totalJaAbatidoDoPrincipal = baixasDoTitulo.content.reduce((soma, baixa) =>
			soma + Number(baixa.valorPagamento || 0) + Number(baixa.valorDesconto || 0), 0)

		const saldoDoPrincipal = Number((tituloAtualizado.valor - totalJaAbatidoDoPrincipal).toFixed(2))

		if (Number(this.baixaDePagamento.valorPagamento || 0) > saldoDoPrincipal) {
			return `O saldo do título mudou (saldo atual: R$ ${formatarMoeda(saldoDoPrincipal)}). Reabra a tela de títulos para refazer a baixa.`
		}

		return null
	}

	async buscarTipoDePagamentoDoTef() {
		if (!this.titulo || !this.titulo.loja) return null

		try {
			const tiposDePagamento = await this.pagamentoService.buscarTipoDePagamentoPorForma(
				this.formaDePagamento as FormaDePagamento,
				this.titulo.loja.id,
			)

			const tipoDePagamento = tiposDePagamento.find(tipo => !tipo.inativo) || null

			if (!tipoDePagamento) {
				AlertModule.setError(`A loja não possui tipo de pagamento ativo para ${this.formaDePagamento}.`)
			}

			return tipoDePagamento
		} catch (error: any) {
			AlertModule.setError(error)
			return null
		}
	}

	efetuarPagamentoTefControlPay(pdvId: string) {
		setTimeout(async () => {
			if (!this.pagamentoTef) return

			const pagamento = this.pagamentoTef
			this.contadorTef++

			if (this.contadorTef === 1 && pagamento.detalhesDoPagamentoId == null) {
				try {
					this.situacaoPagamentoTef = 'Selecionando pagamento'

					const detalhes = await this.pagamentoService.efetuarPagamentoTef(
						pdvId,
						pagamento,
						this.identificadorDoPagamentoTef,
					)

					this.situacaoPagamentoTef = this.descricaoDoStatusDoTef(detalhes)
					pagamento.detalhesDoPagamentoId = detalhes.id
					this.salvarEstadoDoTefEmAndamento(pdvId, true)

					this.efetuarPagamentoTefControlPay(pdvId)
				} catch (error: any) {
					if (error.response?.status === 504) {
						this.reconsultarDetalhesDoPagamentoTef(pdvId)
					} else {
						this.zerarPagamentoTef()
						this.limparEstadoDoTefEmAndamento()
						AlertModule.setError(error)
					}
				}
				return
			}

			if (!pagamento.detalhesDoPagamentoId) {
				this.reconsultarDetalhesDoPagamentoTef(pdvId)
				return
			}

			try {
				const detalhes = await this.pagamentoService.consultarPagamentoTef(
					pdvId,
					pagamento.detalhesDoPagamentoId,
				)

				this.retornoDoAdquirenteTef = detalhes.msgAdquirente
				this.situacaoPagamentoTef = this.descricaoDoStatusDoTef(detalhes)

				if (!this.statusDoTefFinalizado(detalhes)) {
					this.efetuarPagamentoTefControlPay(pdvId)
					return
				}

				await this.concluirPagamentoTef(detalhes)
			} catch (error: any) {
				this.zerarPagamentoTef()
				AlertModule.setError(error)
			}
		}, 5000)
	}

	efetuarPagamentoTefSitef(pdvId: string) {
		setTimeout(async () => {
			if (!this.pagamentoTef) return

			const pagamento = this.pagamentoTef
			this.contadorTef++

			if (this.contadorTef === 1 && pagamento.detalhesDoPagamentoId == null) {
				try {
					this.situacaoPagamentoTef = 'Selecionando pagamento'

					const detalhes = await this.pagamentoService.efetuarPagamentoSitef(
						pdvId,
						pagamento,
						this.identificadorDoPagamentoTef,
					)

					this.situacaoPagamentoTef = this.descricaoDoStatusDoSitef(detalhes)
					pagamento.detalhesDoPagamentoId = detalhes.id
					this.salvarEstadoDoTefEmAndamento(pdvId, false)

					this.efetuarPagamentoTefSitef(pdvId)
				} catch (error: any) {
					if (error.response?.status === 504) {
						this.reconsultarDetalhesDoPagamentoTef(pdvId)
					} else {
						this.zerarPagamentoTef()
						this.limparEstadoDoTefEmAndamento()
						AlertModule.setError(error)
					}
				}
				return
			}

			if (!pagamento.detalhesDoPagamentoId) {
				this.reconsultarDetalhesDoPagamentoTef(pdvId)
				return
			}

			try {
				const detalhes = await this.pagamentoService.buscarDetalhesDoPagamento(
					pagamento.detalhesDoPagamentoId,
				)

				this.retornoDoAdquirenteTef = detalhes.msgAdquirente
				this.situacaoPagamentoTef = this.descricaoDoStatusDoSitef(detalhes)

				if (!this.statusDoTefFinalizado(detalhes)) {
					this.efetuarPagamentoTefSitef(pdvId)
					return
				}

				await this.concluirPagamentoTef(detalhes)
			} catch (error: any) {
				this.zerarPagamentoTef()
				AlertModule.setError(error)
			}
		}, 5000)
	}

	async reconsultarDetalhesDoPagamentoTef(pdvId: string) {
		if (!this.pagamentoTef) return

		const ehControlPay = !!this.configuracaoDaLojaDoTitulo?.integracaoControlPayAtiva

		if (ehControlPay) {
			this.zerarPagamentoTef()
			this.limparEstadoDoTefEmAndamento()
			return AlertModule.setError('Não foi possível confirmar o pagamento junto ao terminal. Confira a transação no terminal antes de repetir a baixa.')
		}

		this.tentativasEfetuarTef++

		const tentativasMaximas = 20

		if (this.tentativasEfetuarTef > tentativasMaximas) {
			this.zerarPagamentoTef()
			this.limparEstadoDoTefEmAndamento()
			return AlertModule.setError('Não foi possível encontrar os dados de pagamento. Confira a transação no terminal antes de repetir a baixa.')
		}

		try {
			const detalhes = await this.pagamentoService.consultarDetalhesDoPagamentoPeloIdentificador(
				this.identificadorDoPagamentoTef,
			)

			this.pagamentoTef.detalhesDoPagamentoId = detalhes.id
			this.salvarEstadoDoTefEmAndamento(pdvId, false)

			this.efetuarPagamentoTefSitef(pdvId)
		} catch (error: any) {
			if (error.response?.status === 404) {
				setTimeout(() => this.reconsultarDetalhesDoPagamentoTef(pdvId), 5000)
			} else {
				this.zerarPagamentoTef()
				AlertModule.setError(error)
			}
		}
	}

	async concluirPagamentoTef(detalhes: DetalhesDoPagamento) {
		if (!this.statusDoTefAprovado(detalhes)) {
			this.zerarPagamentoTef()
			this.limparEstadoDoTefEmAndamento()
			return AlertModule.setError(detalhes.msgAdquirente || 'Pagamento TEF não aprovado.')
		}

		if (await this.baixaJaExisteParaODetalhe(detalhes.id)) {
			this.zerarPagamentoTef()
			this.limparEstadoDoTefEmAndamento()
			this.$emit('atualizar', this.baixaDePagamento)
			return AlertModule.setInfo('A baixa deste pagamento TEF já estava registrada.')
		}

		const tituloDesatualizado = await this.validarTituloParaPagamentoTef()

		if (tituloDesatualizado) {
			this.zerarPagamentoTef()
			this.limparEstadoDoTefEmAndamento()
			return AlertModule.setError(
				`${tituloDesatualizado} O pagamento de R$ ${formatarMoeda(this.valorTotalRecebidoNaBaixa)} foi aprovado no terminal (NSU ${detalhes.nsu || detalhes.numeroAutorizacao || '-'}) e precisa ser conciliado.`,
			)
		}

		const identificadorDaTransacao = detalhes.nsu || detalhes.numeroAutorizacao

		if (identificadorDaTransacao) {
			this.baixaDePagamento.transactionId = identificadorDaTransacao
		}

		this.baixaDePagamento.detalhesDoPagamentoId = detalhes.id

		const comprovantesDoTef = [detalhes.comprovanteAdquirente, detalhes.comprovanteLoja]
			.filter((comprovante): comprovante is string => !!comprovante)

		this.zerarPagamentoTef()
		await this.efetivarBaixa(comprovantesDoTef)
	}

	salvarEstadoDoTefEmAndamento(pontoDeVendaId: string, ehControlPay: boolean) {
		if (!this.titulo) return

		const detalhesDoPagamentoId = this.pagamentoTef?.detalhesDoPagamentoId

		if (!detalhesDoPagamentoId) return

		const estadoAnterior = this.lerEstadoDoTefEmAndamento()
		const ehMesmaTransacao = !!estadoAnterior
			&& estadoAnterior.identificador === this.identificadorDoPagamentoTef

		const estado: TefDaBaixaEmAndamento = {
			criadoEm: ehMesmaTransacao && estadoAnterior ? estadoAnterior.criadoEm : Date.now(),
			tituloId: this.titulo.id,
			pontoDeVendaId: pontoDeVendaId,
			ehControlPay: ehControlPay,
			identificador: this.identificadorDoPagamentoTef,
			detalhesDoPagamentoId: detalhesDoPagamentoId,
			formaDePagamento: this.formaDePagamento,
			data: this.data,
			horas: this.horas,
			baixaDePagamento: { ...this.baixaDePagamento },
			tipoDeDesconto: this.tipoDeDesconto,
			valorDeDescontoNosJuros: this.valorDeDescontoNosJuros,
			valorDeDescontoNaMulta: this.valorDeDescontoNaMulta,
			valorDescontoTituloEmPorcentagem: this.valorDescontoTituloEmPorcentagem,
			valorDescontoJurosDoTituloEmPorcentagem: this.valorDescontoJurosDoTituloEmPorcentagem,
			valorDescontoMultaDoTituloEmPorcentagem: this.valorDescontoMultaDoTituloEmPorcentagem,
			valorJurosSobreBaixa: this.valorJurosSobreBaixa,
			valorDaMultaSobreBaixa: this.valorDaMultaSobreBaixa,
			valorIntegroDoTituloRestante: this.valorIntegroDoTituloRestante,
			valorFaltante: this.valorFaltante,
			valorFaltanteInicial: this.valorFaltanteInicial,
			valorFaltanteDoTitulo: this.valorFaltanteDoTitulo,
			valorTotalTitulo: this.valorTotalTitulo,
		}

		localStorage.setItem(TEF_DA_BAIXA_EM_ANDAMENTO, JSON.stringify(estado))
	}

	lerEstadoDoTefEmAndamento(): TefDaBaixaEmAndamento | null {
		try {
			const estado = localStorage.getItem(TEF_DA_BAIXA_EM_ANDAMENTO)

			return estado ? JSON.parse(estado) : null
		} catch {
			return null
		}
	}

	limparEstadoDoTefEmAndamento() {
		localStorage.removeItem(TEF_DA_BAIXA_EM_ANDAMENTO)
	}

	async retomarTefEmAndamento() {
		if (!this.titulo) return false

		const estado = this.lerEstadoDoTefEmAndamento()

		if (!estado) return false

		const criadoEm = Number(estado.criadoEm)

		if (!criadoEm || Date.now() - criadoEm > VALIDADE_DO_TEF_EM_ANDAMENTO_EM_MS) {
			this.limparEstadoDoTefEmAndamento()
			return false
		}

		if (estado.tituloId !== this.titulo.id) return false

		this.formaDePagamento = estado.formaDePagamento
		this.data = estado.data
		this.horas = estado.horas
		this.baixaDePagamento = { ...estado.baixaDePagamento }
		this.tipoDeDesconto = estado.tipoDeDesconto
		this.valorDeDescontoNosJuros = estado.valorDeDescontoNosJuros
		this.valorDeDescontoNaMulta = estado.valorDeDescontoNaMulta
		this.valorDescontoTituloEmPorcentagem = estado.valorDescontoTituloEmPorcentagem
		this.valorDescontoJurosDoTituloEmPorcentagem = estado.valorDescontoJurosDoTituloEmPorcentagem
		this.valorDescontoMultaDoTituloEmPorcentagem = estado.valorDescontoMultaDoTituloEmPorcentagem
		this.valorJurosSobreBaixa = estado.valorJurosSobreBaixa
		this.valorDaMultaSobreBaixa = estado.valorDaMultaSobreBaixa
		this.valorIntegroDoTituloRestante = estado.valorIntegroDoTituloRestante
		this.valorFaltante = estado.valorFaltante
		this.valorFaltanteInicial = estado.valorFaltanteInicial
		this.valorFaltanteDoTitulo = estado.valorFaltanteDoTitulo
		this.valorTotalTitulo = estado.valorTotalTitulo
		this.dataInicial = estado.data

		this.identificadorDoPagamentoTef = estado.identificador

		const detalhes = await this.consultarDesfechoDoTefEmAndamento(estado)

		if (!detalhes) return false

		if (!this.statusDoTefFinalizado(detalhes)) {
			AlertModule.setWarning(
				`O pagamento TEF de R$ ${formatarMoeda(this.valorTotalRecebidoNaBaixa)} desta baixa continua aguardando no terminal. Conclua ou cancele no terminal e reabra esta baixa para finalizar.`,
			)
			return false
		}

		if (!this.statusDoTefAprovado(detalhes)) {
			this.limparEstadoDoTefEmAndamento()
			AlertModule.setError(detalhes.msgAdquirente || 'O pagamento TEF desta baixa não foi aprovado.')
			return false
		}

		await this.concluirPagamentoTef(detalhes)
		return true
	}

	async consultarDesfechoDoTefEmAndamento(estado: TefDaBaixaEmAndamento) {
		try {
			this.salvando = true

			return estado.ehControlPay
				? await this.pagamentoService.consultarPagamentoTef(estado.pontoDeVendaId, estado.detalhesDoPagamentoId)
				: await this.pagamentoService.buscarDetalhesDoPagamento(estado.detalhesDoPagamentoId)
		} catch (error: any) {
			if (error.response?.status === 404) {
				this.limparEstadoDoTefEmAndamento()
				return null
			}

			AlertModule.setError(error)
			return null
		} finally {
			this.salvando = false
		}
	}

	zerarPagamentoTef() {
		this.mostraAguardandoPagamentoTef = false
		this.aguardandoPagamentoTef = false
		this.situacaoPagamentoTef = ''
		this.retornoDoAdquirenteTef = null
		this.contadorTef = 0
		this.tentativasEfetuarTef = 0
		this.pagamentoTef = null
		this.identificadorDoPagamentoTef = ''
		this.salvando = false
	}

	statusDoTefFinalizado(detalhes: DetalhesDoPagamento) {
		switch (detalhes.status) {
			case '3':
			case '5':
			case '6':
			case '18':
			case '19':
			case '30':
				return false
			default:
				return true
		}
	}

	statusDoTefAprovado(detalhes: DetalhesDoPagamento) {
		return detalhes.status === '10'
	}

	descricaoDoStatusDoTef(detalhes: DetalhesDoPagamento) {
		switch (detalhes.status) {
			case '5':
			case '6':
				this.aguardandoPagamentoTef = true
				return 'Aguardando pagamento, insira ou aproxime o cartão'
			case '10':
				return 'Pagamento finalizado'
			case '15':
			case '25':
				return 'Pagamento recusado'
			case '20':
				return 'Pagamento cancelado'
			default:
				return 'Situação do pagamento indefinida'
		}
	}

	descricaoDoStatusDoSitef(detalhes: DetalhesDoPagamento) {
		if (detalhes.status === '3') {
			this.aguardandoPagamentoTef = true
			return detalhes.msgAdquirente
		}

		return this.descricaoDoStatusDoTef(detalhes)
	}

	limparDados() {
		this.cancelarRedistribuicaoPendente()
		this.mostra = false
		this.data = ''
		this.horas = ''
		this.formaDePagamento = ''
		this.valorFaltante = null
		this.valorFaltanteAtualizado = null
		this.baixaDePagamento = {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
			formaDePagamento: null,
			valorDesconto: 0,
			turnoDeVendaId: null,
			tipoDeTransacao: null,
			estornado: null,
			valorJurosSobreBaixa: 0,
			valorDaMultaSobreBaixa: 0,
			valorTotalTitulo: 0,
			valorDeDescontoNosJuros: 0,
			valorDeDescontoNaMulta: 0,
			tipoDeDesconto: this.tipoDeDesconto,
		}
		this.valorDeDescontoNosJuros = 0
		this.valorDeDescontoNaMulta = 0
		this.valorDescontoTituloEmPorcentagem = 0
		this.valorDescontoJurosDoTituloEmPorcentagem = 0
		this.valorDescontoMultaDoTituloEmPorcentagem = 0
		this.tipoDeDesconto = 'valorFixo'
		this.zerarPagamentoTef()
	}

	cancelar() {
		this.limparDados()
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
		this.dataInicial = this.data;
	}

	alternarDistribuicao() {
		if (this.estadoDistribuidor === 0) {
			this.distribuirValores();
			this.estadoDistribuidor = 1;
		} else {
			this.cancelarRedistribuicaoPendente()
			this.baixaDePagamento.valorDaMultaSobreBaixa = 0
			this.baixaDePagamento.valorJurosSobreBaixa = 0
			this.baixaDePagamento.valorPagamento = 0
			this.baixaDePagamento.valorTotalTitulo = 0
			this.estadoDistribuidor = 0;
			this.resetaDesconto()
		}
	}

	validarDescontoEmPorcentagem(value) {
		if(value !== '' && value !== null && value !== undefined) {
			const porcentagem = Number(value);
			
			if ((!Number.isInteger(porcentagem) || porcentagem < 0 || porcentagem > 100) && value !== '') {
				return 'A porcentagem deve ser um número inteiro entre 0 e 100.';
			}
			
			return true;
		}
	}

	@Watch('tipoDeDesconto')
	resetaDesconto(){
		this.baixaDePagamento.valorDesconto = 0
		this.valorDeDescontoNosJuros = 0
		this.valorDeDescontoNaMulta = 0
		this.baixaDePagamento.valorDeDescontoNosJuros = 0
		this.baixaDePagamento.valorDeDescontoNaMulta = 0
		this.valorDescontoTituloEmPorcentagem = 0
		this.valorDescontoJurosDoTituloEmPorcentagem = 0
		this.valorDescontoMultaDoTituloEmPorcentagem = 0
		this.calcularValorFaltante()
	}

	get calcularReducaoDeJuros() {
		if(this.titulo?.formaDePagamento !== 'CREDIARIO' && this.titulo?.formaDePagamento !== 'BOLETO') return formatarMoeda(0);

		const juros = Number(this.valorJurosSobreBaixa) || 0;

		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = this.valorDescontoJurosDoTituloEmPorcentagem / 100;
			const valorFinal = juros - (juros * porcentagem);

			return formatarMoeda(Math.max(0, valorFinal - Number(this.baixaDePagamento.valorJurosSobreBaixa)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorJurosSobreBaixa) - Number(this.valorDeDescontoNosJuros) || 0));
		}
	}

	get calcularReducaoDeMulta() {
		if(this.titulo?.formaDePagamento !== 'CREDIARIO' && this.titulo?.formaDePagamento !== 'BOLETO') return formatarMoeda(0);

		const multa = Number(this.valorDaMultaSobreBaixa) || 0;

		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = this.valorDescontoMultaDoTituloEmPorcentagem / 100;
			const valorFinal = multa - (multa * porcentagem);

			return formatarMoeda(Math.max(0, valorFinal - Number(this.baixaDePagamento.valorDaMultaSobreBaixa)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorDaMultaSobreBaixa) - Number(this.valorDeDescontoNaMulta) || 0));
		}
	}

	get calcularReducaoDeTitulo() {
		const valorTituloFaltante = Number(this.valorFaltanteDoTitulo) + Number(this.baixaDePagamento.valorDesconto) || 0;
		const desconto = Number(this.valorDescontoTituloEmPorcentagem) || 0;
		
		if(this.tipoDeDesconto === 'porcentagem'){
			const porcentagem = desconto / 100;

			// Sem descontar o pagamento aqui. Este getter alimenta o "Saldo Total" da tela E o
			// valorAtualizado enviado ao backend, e o backend usa esse número como saldo de
			// PARTIDA, subtraindo pagamento e perdão por conta própria. Descontar aqui fazia o
			// saldo chegar lá já projetado e ser descontado duas vezes: num título de 500,00 com
			// 300,00 pagos e 17,10 de encargos perdoados, o backend chegava a 200 - 300 - 17,10,
			// clampava em zero e marcava o título como PAGO com 200,00 ainda em aberto. Pior, como
			// o saldo zerou, o recálculo que corrigiria isso é pulado (ele só roda com saldo > 0),
			// então o erro ficava gravado.
			//
			// O ramo de valor fixado abaixo nunca subtraiu, e é justamente por isso que ele
			// sempre funcionou. Os dois passam a informar a mesma coisa.
			return formatarMoeda(Math.max(0, valorTituloFaltante - (valorTituloFaltante * porcentagem)));
		}else{
			return formatarMoeda(Math.max(0,Number(this.valorFaltanteDoTitulo)));
		}
	}

	/**
	 * Sobra do valor recebido depois de alocar multa, juros e principal.
	 *
	 * Medir pelo saldo restante não funciona: no desconto em porcentagem os getters de
	 * redução já abatem o que foi alocado, então o saldo cai a zero e o valor digitado
	 * inteiro aparecia como troco. Aqui a conta é direta, o recebido menos o distribuído.
	 */
	get troco(): number {
		const recebido = Number(this.baixaDePagamento.valorTotalTitulo || 0)
		const distribuido = Number(this.baixaDePagamento.valorPagamento || 0)
			+ Number(this.baixaDePagamento.valorJurosSobreBaixa || 0)
			+ Number(this.baixaDePagamento.valorDaMultaSobreBaixa || 0)

		return Math.max(0, Number((recebido - distribuido).toFixed(2)))
	}

	get calcularReducaoDeTituloCompleto(){
		return Math.max(0,  Number(this.calcularReducaoDeJuros.replace(/\./g, '').replace(',', '.')) +
						Number(this.calcularReducaoDeMulta.replace(/\./g, '').replace(',', '.')) +
						Number(this.calcularReducaoDeTitulo.replace(/\./g, '').replace(',', '.')))
	}

	get acrescimo(): number {
		if (this.fluxo === 'Entrada') return 0
		const valorPago = Number(this.baixaDePagamento.valorPagamento || 0)
		const valorFaltante = Number(this.valorFaltante || 0)
		return Math.max(0, Number((valorPago - valorFaltante).toFixed(2)))
	}

}
